import { all } from 'redux-saga/effects'

import { sagas as userSagas } from './user'

export function * rootSaga() {
  yield all([
    ...userSagas,
  ])
}
